import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { provideEffects } from '@ngrx/effects';
import { NavigationActionTiming, provideRouterStore } from '@ngrx/router-store';
import { provideStore } from '@ngrx/store';

import * as a from './actions';
import { CustomSerializer } from './custom-route-serializer';
import * as e from './effects';
import { metaReducers, reducers } from './reducers';
import * as s from './selectors';

export const effects = e.list;
export const selectors = s.list;
export const actions = a.list;

export function provideCoreStore(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideStore(reducers, { metaReducers }),
    provideEffects(effects),
    provideRouterStore({
      serializer: CustomSerializer,
      navigationActionTiming: NavigationActionTiming.PostActivation,
    }),
    actions,
    selectors,
  ]);
}
